import { ForwardedRef, PropsWithChildren } from 'react';
import Menu, { MenuProps } from '@mui/material/Menu';

export type MagicBellInboxMenuProps = PropsWithChildren &
  MenuProps & {
    menuRef: ForwardedRef<HTMLDivElement | null>;
  };

export default function MagicBellInboxMenu({
  children,
  menuRef,
  ...props
}: MagicBellInboxMenuProps) {
  return (
    <Menu
      id="notification-menu"
      keepMounted
      MenuListProps={{
        sx: { padding: 0 },
        'aria-labelledby': 'notification-menu-button',
      }}
      slotProps={{
        paper: {
          sx: { marginLeft: 11, width: 450, height: 450 },
          ref: menuRef,
        },
      }}
      {...props}
    >
      {children}
    </Menu>
  );
}
